<script>
    import _            from 'lodash'
    import * as api     from '../../shared/api.js'
    import * as pages   from '../../shared/pages.js'
    import { company, domains }  from '../../shared/stores.js'
    import Loader       from '../../shared/Loader.svelte'
    import SectionTitle from '../../shared/SectionTitle.svelte'
    import Item         from '../../shared/Item.svelte'
    import BannerPreview from './BannerPreview.svelte'

    export let id

    let active    = -1
    let items     = []
    let loading   = true
    let error     = false
    let banner    = null
    let consent   = null
    let archetype = empty()
    let copied    = false
    let verifyingDomain = false
    let verifyResult = 0

    $: disableVerifyButton = verifyingDomain || verifyResult === 200
    $: verifyMessage       = verifyingDomain ? 'Verificando DNS' : verifyMessageFrom(verifyResult)
    $: verifyMessageClass  = verifyingDomain ? 'violet'          : verifyMessageClassFrom(verifyResult)

    function verifyMessageClassFrom(verifyResult) {
        switch(verifyResult) {
            case 200: return 'green'
            case 404: return 'orange'
            case 406: return 'red'
            default : return 'violet'
        } 
    }

    function verifyMessageFrom(verifyResult) {
        switch(verifyResult) {
            case 200: return 'Domínio configurado corretamente'
            case 404: return 'Domínio não configurado. Adicione a entrada de DNS'
            case 406: return 'Domínio configurado incorretamente'
            default : return null
        } 
    }

    function empty() {
        return { id: 0, name: '', domain: '' }
    }

    function assemble(company, it) {
        return { 
            id      : it.id, 
            company : company.id, 
            name    : it.name, 
            domain  : it.domain 
        }
    }

    function sort(it) {
        return it.name
    }

    const urls = {
        onMount : (company)     => { return `/domains/company/${company.id}` },
        onRemove: (company, it) => { return `/domain/${it.id}` },
        onUpdate: (company, it) => { return '/domain' }
    }

    function onDestroy() {
        items = []
    }
    
    function onRemove(it) {
        return pages.onRemove(urls.onRemove($company, it)).then(res => {
            items = items.filter(i => i.id !== it.id)
            domains.set(items)
            return true
        })
    }

    function onUpdate(it) {
        
        const method = it.id === 0 ? 'POST' : 'PUT'
        const payload = assemble($company, it)

        return pages.onUpdate(urls.onUpdate($company, it), method, payload).then(json => {
            archetype = empty()
            let array = items
            let toAdd = json
            if(it.id > 0) {
                array = items.filter(i => i.id !== it.id)
                toAdd = it
            }
            items = _.sortBy([...array, toAdd], sort)
            domains.set(items)
            return true
        })
    }

    function isDirty(item, copy) {
        return ! _.isEqual(item, copy)
    }

    function actions(item) {
        return [{
            id              : 'dns',
            name            : 'DNS', 
            triggerLoading  : false ,
            onClick         : () => { 
                verifyingDomain = false
                verifyResult    = 0
                return Promise.resolve({}) 
            }
        }, {
            id              : 'banner',
            name            : 'Central da Privacidade', 
            triggerLoading  : true,
            onClick         : () => { 
                banner = null
                copied = false
                return Promise.resolve(true) 
            }
        }]
    }

    function verifyDomain(item) {
        verifyingDomain = true
        api .get(`/domain/${item.id}/verify`)
            .then(res => {
                setTimeout(() => {
                    verifyingDomain = false
                    verifyResult    = res.status
                }, 500)
            })
            .catch(console.log)
    }

    pages.onMount(urls.onMount($company)).then(it => {
        items = it
        loading = false
    }).catch(err => {
        error = err
        loading = false
    })

</script>

<style>
    .item .ui.label {
        width: 100px;
    }

    .item {
        margin: 1em 0;
    }

    .detail {
        color: #ccc; 
        font-size: 12pt !important;
    }

    .banner, .dns {
        background-color: var(--main-bg-color);
        margin  : 20px 0 !important;
        padding : 30px !important;
        border-radius: 3px;
    }

    .banner .code {
        font-family: monospace;
        white-space: pre;
        color: #bbb;
    }

    #code {
        display: none;
    }

    .dns-message {
        display        : flex;
        flex-direction : row;
        align-items    : center;
    }

    .dns-message > div {
        padding   : 1em 1em 0 1em;
        color     : #444;
        font-size : 12pt;
    }
    
    small {
        font-size: 60%;
    }    
</style>

{#if loading || error}
    <Loader {error} what="Carregando" inverted={true} />
{:else}
    <SectionTitle>Central da Privacidade</SectionTitle>

    <div class="ui raised segments">
        <Item debug={false} item={archetype} bind:active={active} {isDirty} {onUpdate}>
            <div slot="primary">
                <div class="item">
                    <div class="ui labeled big input" >
                    <div class="ui label">Nome</div>
                        <input  bind:value={archetype.name}
                                type="text"
                                autocomplete="false">
                    </div>
                </div>
                <div class="item">
                    <div class="ui labeled big input" >
                    <div class="ui label">Domínio</div>
                        <input  bind:value={archetype.domain}
                                type="text" 
                                autocomplete="false">
                    </div>
                </div>
            </div>        
        </Item>
        {#if items.length === 0}
            <div class="ui segment">
                <div class="ui big message">
                    Não existem domínios cadastrados ainda
                </div>
            </div>
        {/if}
        {#each items as item (item.id)}
            <Item   debug={false}
                    bind:item={item} 
                    bind:active={active} 
                    {isDirty} 
                    {onUpdate} 
                    {onRemove} 
                    actions={actions(item)}
                    let:action={action}>
                <span slot="header" >
                    <span class="name">{item.name}</span>
                    <span class="description">{item.domain}</span>
                </span>
                <div slot="secondary">
                    {#if item.id === active}
                        {#if action && "dns" === action.id}
                            <div class="dns">
                                <div class="ui message {verifyMessageClass}">
                                    <button class="ui button {verifyMessageClass}" 
                                            class:disabled={disableVerifyButton}
                                            class:loading={verifyingDomain}
                                            on:click={e => verifyDomain(item)}>Verificar as configurações de DNS</button>
                                    {#if verifyMessage}
                                        {verifyMessage}
                                    {/if}
                                </div>
                                <div class="dns-message">
                                    <div>
                                        <i class="exclamation circle big grey icon"></i>
                                    </div>
                                    <div>
                                        <!-- <p>
                                            Para que seu site funcione corretamente com as ferramentas que a Dogma oferece
                                            é necessário que seja criada uma nova entrada no DNS do seu domínio apontando
                                            para o servidor da Dogma.
                                        </p> -->
                                        <p>
                                            É necessário criar uma entrada chamada <b>dogma</b> do tipo <b>CNAME</b> 
                                            no servidor de DNS do domínio <b>{item.domain}</b> apontando para o <i>host</i> 
                                            <b>api.dogma.legal</b>. <br/>
                                            A configuração final ficaria assim:

                                        </p>
                                        <div style="margin: 8px 0px 16px 0px">
                                            <span class="ui grey large label">
                                                dogma.{item.domain} CNAME api.dogma.legal
                                            </span>
                                        </div>
                                        <p>
                                            Você precisa de ajuda para fazer isso? <br/>
                                            Entre em contato com a nossa equipe de <a href="mailto:suporte@dogma.legal">suporte</a>. Nós queremos te ajudar.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        {:else if action && "banner" === action.id}
                            <div class="">
                                <BannerPreview {item}></BannerPreview>
                            </div>
                        {:else}
                            <div>NO ACTION</div>
                        {/if}
                    {/if}
                </div>
                <div slot="primary">
                    <div class="item">
                        <div class="ui labeled big input" >
                        <div class="ui label">Nome</div>
                            <input  bind:value={item.name}
                                    type="text"
                                    autocomplete="false">
                        </div>
                    </div>
                    <div class="item">
                        <div class="ui labeled big input" >
                        <div class="ui label">Domínio</div>
                            <input  bind:value={item.domain}
                                    type="text" 
                                    autocomplete="false" 
                                    disabled>
                        </div>
                    </div>
                </div>
            </Item>
        {/each}    
    </div>
{/if}